/**
 * NZSC-4027: 안심 매매 패키지 랜딩 진입 경로(?from=) 허용값.
 * 랜딩 view 이벤트의 entry 속성으로 실려 경로별 랜딩→step1 전환율을 분리 측정한다.
 *   bumper    — 결제완료 넛지 → 범퍼 콘텐츠 페이지 CTA
 *   screening — 매매리포트 권원보험 가심사 카드 CTA
 *   snackbar  — 매매리포트 사기 유형 탭 스낵바 CTA
 *   gnb       — 하단 네비 매매보증 탭(NZSC-4145, 가입 내역 없는 유저)
 *   home      — 홈 매매 지킴 보증 카드(NZSC-4145, web-core 만 보낸다)
 *   mypage    — 마이페이지 안심매매패키지 바로가기(NZSC-4145, web-core 만 보낸다)
 *   (없음)    — direct
 * web-core src/lib/insurance/firstamBumper.ts LANDING_ENTRIES 와 같은 값을 유지한다.
 */
export const FIRSTAM_LANDING_ENTRY = {
  BUMPER: "bumper",
  SCREENING: "screening",
  SNACKBAR: "snackbar",
  GNB: "gnb",
  HOME: "home",
  MYPAGE: "mypage",
};

export const FIRSTAM_LANDING_ENTRIES = Object.values(FIRSTAM_LANDING_ENTRY);

export const FIRSTAM_LANDING_PATH = "/insurance/firstamerican/title-001/landing";

/** 랜딩으로 가는 라우터 location — from 을 쿼리로 싣는다. */
export function fnFirstamLandingLocation(from) {
  return { path: FIRSTAM_LANDING_PATH, query: { from } };
}
